/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterJob,
  PresenterJournalLinkageResultResponse,
  PresenterNetsuiteCompanyInformationResponse,
  PresenterNetsuiteCredentialRequest,
  PresenterNetsuiteCredentialResponse,
  PresenterNetsuiteInformationCompanyRequest,
  PresenterNetsuiteInformationCompanyResponse,
  PresenterNetsuiteKeyResponse,
  PresenterNetsuiteRevokeCredentialResponse,
  PresenterNetsuiteStatusResponse,
  PresenterNetsuiteSubsidiariesResponse,
  PresenterResponse,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class Netsuite<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * @description Get NetSuite company information.
   *
   * @tags netsuite
   * @name CompanyInformationList
   * @request GET:/netsuite/company_information
   */
  companyInformationList = (
    query?: {
      office_id?: number
      'page[number]'?: number
      'page[size]'?: number
      sort?: string[]
    },
    params: RequestParams = {}
  ) =>
    this.http.request<PresenterNetsuiteCompanyInformationResponse[], PresenterError>({
      path: `/netsuite/company_information`,
      method: 'GET',
      query: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Connect and save NetSuite credential.
   *
   * @tags netsuite
   * @name CredentialsCreate
   * @request POST:/netsuite/credentials
   */
  credentialsCreate = (body: PresenterNetsuiteCredentialRequest, params: RequestParams = {}) =>
    this.http.request<PresenterNetsuiteCredentialResponse, PresenterError>({
      path: `/netsuite/credentials`,
      method: 'POST',
      body: body,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Export Netsuite template data.
   *
   * @tags netsuite
   * @name ExportList
   * @request GET:/netsuite/export
   */
  exportList = (
    query: {
      /** export type, 1=all, 2=current mapping */
      export_type: string
      /** csv charset, if it's not shift_jis, utf-8 is used (value: shift_jis) */
      charset?: string
    },
    params: RequestParams = {}
  ) =>
    this.http.request<File, any>({
      path: `/netsuite/export`,
      method: 'GET',
      query: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Import NetSuite account mapping data from CSV file
   *
   * @tags netsuite
   * @name ImportUpdate
   * @summary Import NetSuite Account Mapping CSV
   * @request PUT:/netsuite/import
   */
  importUpdate = (
    data: {
      /** NetSuite account mapping CSV file to import */
      file: File
      /** Character set of the CSV file (default: utf-8, other: shift_jis) */
      charset?: string
    },
    params: RequestParams = {}
  ) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/netsuite/import`,
      method: 'PUT',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })
  /**
   * @description get journal list with status of a linkage history
   *
   * @tags netsuite
   * @name JournalLinkageHistoryDetailList
   * @summary get journal list of a linkage history
   * @request GET:/netsuite/journal_linkage_history_detail
   */
  journalLinkageHistoryDetailList = (
    query: {
      /** ID of a linkage history */
      linkage_history_id: number
    },
    params: RequestParams = {}
  ) =>
    this.http.request<PresenterJournalLinkageResultResponse, PresenterError>({
      path: `/netsuite/journal_linkage_history_detail`,
      method: 'GET',
      query: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description send journals to Netsuite
   *
   * @tags netsuite
   * @name JournalLinkageSubmitCreate
   * @summary send journals to Netsuite
   * @request POST:/netsuite/journal_linkage_submit
   */
  journalLinkageSubmitCreate = (params: RequestParams = {}) =>
    this.http.request<PresenterJob, any>({
      path: `/netsuite/journal_linkage_submit`,
      method: 'POST',
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Retrieve certificate for authenticating with NetSuite. New certificate will be generated if not exist.
   *
   * @tags netsuite
   * @name PostNetsuite
   * @summary Retrieve NetSuite certificate
   * @request POST:/netsuite/key
   */
  postNetsuite = (params: RequestParams = {}) =>
    this.http.request<PresenterNetsuiteKeyResponse, PresenterError>({
      path: `/netsuite/key`,
      method: 'POST',
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Revoke Netsuite credential
   *
   * @tags netsuite
   * @name RevokeDelete
   * @summary Revoke the credential for Netsuite
   * @request DELETE:/netsuite/revoke
   */
  revokeDelete = (params: RequestParams = {}) =>
    this.http.request<PresenterNetsuiteRevokeCredentialResponse, PresenterError>({
      path: `/netsuite/revoke`,
      method: 'DELETE',
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Get NetSuite connection status. Returns status values: 1=Not Connected, 2=Connected
   *
   * @tags netsuite
   * @name StatusList
   * @request GET:/netsuite/status
   */
  statusList = (params: RequestParams = {}) =>
    this.http.request<PresenterNetsuiteStatusResponse, PresenterError>({
      path: `/netsuite/status`,
      method: 'GET',
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Get NetSuite subsidiaries.
   *
   * @tags netsuite
   * @name SubsidiariesList
   * @summary Get NetSuite subsidiaries
   * @request GET:/netsuite/subsidiaries
   */
  subsidiariesList = (params: RequestParams = {}) =>
    this.http.request<PresenterNetsuiteSubsidiariesResponse, PresenterError>({
      path: `/netsuite/subsidiaries`,
      method: 'GET',
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * @description Save NetSuite information company.
   *
   * @tags netsuite
   * @name SubsidiaryCreate
   * @request POST:/netsuite/subsidiary
   */
  subsidiaryCreate = (body: PresenterNetsuiteInformationCompanyRequest, params: RequestParams = {}) =>
    this.http.request<PresenterNetsuiteInformationCompanyResponse, PresenterError>({
      path: `/netsuite/subsidiary`,
      method: 'POST',
      body: body,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
